import React from "react";
import styled from "styled-components";

const Wrap = styled.div`
    background-color: #FFFFFF; border: 1px solid #EFEFEF;
    border-radius: 12px; padding: 16px;
    .h { color: #25368D; font-size: 15px; font-weight: 600; margin-bottom: 12px; }
    table { width: 100%; border-collapse: collapse; font-size: 13px; }
    th { text-align: left; color: #838BB4; font-weight: 600; padding: 8px; border-bottom: 1px solid #EFEFEF; }
    td { padding: 10px 8px; border-bottom: 1px solid #F5F5F5; cursor: pointer; }
    tr:hover td { background-color: #F5F7FB; }
    .empty { color: #838BB4; padding: 40px 0; text-align: center; font-size: 13px; }
    .num   { text-align: right; font-variant-numeric: tabular-nums; }
`;

export default function TopListTable({ title, data, columns, onRowClick }) {
    const rows = data || [];
    return (
        <Wrap>
            <div className="h">{title}</div>
            {rows.length === 0 ? <div className="empty">ไม่มีข้อมูล</div> : (
                <table>
                    <thead>
                        <tr>
                            {columns.map(c => <th key={c.key} className={c.type === "num" ? "num" : ""}>{c.label}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((r, i) => (
                            <tr key={i} onClick={() => onRowClick && onRowClick(r)}>
                                {columns.map(c => (
                                    <td key={c.key} className={c.type === "num" ? "num" : ""}>
                                        {r[c.key] === null || r[c.key] === undefined ? "-" : c.type === "num" ? Number(r[c.key]).toLocaleString("en-US") : r[c.key]}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </Wrap>
    );
}
